"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "farindola": {
    "679d4392": [{
      "hkey": "e7e0a7d4",
      "slug": "farindola",
      "name": "Farindola",
      "primary": true,
      "skipSearch": false
    }],
    "rigopiano": [{
      "hkey": "e7e0a7d4",
      "slug": "farindola",
      "name": "Farindola",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "47b921bd": [{
      "hkey": "e7e0a7d4",
      "slug": "farindola",
      "name": "Farindola",
      "primary": true,
      "skipSearch": false
    }],
    "vado-di-sole-valico": [{
      "hkey": "e7e0a7d4",
      "slug": "farindola",
      "name": "Farindola",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;